module.exports = __webpack_public_path__ + "fonts/changePass.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/changePass.svg
// module id = 2024
// module chunks = 0